import React, { useEffect } from 'react'
import { Helmet, HelmetProvider } from 'react-helmet-async'
import { Box, Grid, AppBar, CssBaseline } from '@mui/material'
import { Outlet } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import { grey } from '@mui/material/colors'

import { getAssetURL } from 'lib/utility/GetAssetUrl'
import { useAppSelector } from 'redux/Hook'
import { setI18nLocale } from 'lib/utility/LocaleHelper'
import { fetchSite } from 'redux/thunks/Site'
import { fetchfeatures } from 'redux/thunks/Features'
import { fetchAnonymousUserToken } from 'api/ResponseFormats/Common/AnonymousUser'
import { setValidAuthToken } from 'redux/slices/StakeholderDashboard'
import { initializeSegment, trackCurrentPage } from 'lib/segmentTracker/Segment'

const StakeholderLayout = () => {
  const dispatch = useDispatch()
  const {
    user: { user },
    features: { features },
    site: { site },
  } = useAppSelector((state) => state)

  const setAnonymousUserToken = async () => {
    const { data: isTokenAvaialble } = await fetchAnonymousUserToken()
    if (isTokenAvaialble) {
      dispatch(setValidAuthToken(!!isTokenAvaialble))
      dispatch(fetchSite())
      dispatch(fetchfeatures())
    }
  }

  useEffect(() => {
    setAnonymousUserToken()
  }, [])

  useEffect(() => {
    site.locale && setI18nLocale(site.locale)
  }, [site])

  useEffect(() => {
    const updateSegmentTracker = () => {
      features?.['segment_analytics_admin']?.enabled &&
        trackCurrentPage(
          user,
          site,
          features?.['segment_analytics_admin']?.enabled,
        )
    }
    updateSegmentTracker()
  }, [features])

  const wrapperStyles = {
    bgcolor: grey[100],
  }

  return (
    <>
      <HelmetProvider>
        <Helmet>
          <link
            rel="icon"
            type="image/x-icon"
            href={`${getAssetURL('/sidebar/favicon.ico')}`}
          ></link>
          <script>{initializeSegment()}</script>
        </Helmet>
      </HelmetProvider>
      <Box>
        <AppBar
          color="inherit"
          sx={{
            height: '4rem',
            boxShadow: '0px 2px 8px rgba(0, 0, 0, 0.15)',
          }}
        >
          <Box sx={{ padding: '0.625rem 1.25rem' }}>
            <img
              src={getAssetURL('/sidebar/engagement_logo.svg')}
              alt="EngagementHQ"
              style={{ height: '2.75rem' }}
            />
          </Box>
        </AppBar>
        <Box
          sx={{ display: 'flex', paddingTop: '4rem' }}
          id="stakeHolderLayout"
        >
          <CssBaseline />
          <Box component="main" sx={{ flexGrow: 1, ...wrapperStyles }}>
            <Grid container>
              <Grid
                container
                sx={{
                  px: {
                    xs: 2,
                    sm: 5,
                  },
                  py: {
                    xs: 2,
                    sm: 4,
                  },
                }}
              >
                <Outlet />
              </Grid>
            </Grid>
          </Box>
        </Box>
      </Box>
    </>
  )
}

export default StakeholderLayout
